import type { FC } from 'react';
import React from 'react';

import { Box } from '@atlaskit/primitives';

export const RolesManagementTab: FC = () => {
	return <Box>TODO</Box>;
};
